<template>
  <div class="inline-block-container">

    <div @click="openModalAction" class="add-container">
      <i class="fal fa-edit"></i> 情報変更
    </div>

    <ModalBackground v-if="isActive"/>
    <div v-if="isActive" class="modal-container" @click.self="closeModalAction">
      <div class="inner">
        <div class="close-button-container" @click="closeModalAction">
          <CloseButton/>
        </div>
        <FormHelper class="form-container" @callback="callback" :formSettings="formSettings"/>
      </div>
    </div>
    <div v-if="$isDebug() && debugVerifyToken" class="debug-option-container">
      <router-link :to="{name: 'Register', params:{token: debugVerifyToken}}" class="link">[DEBUG]メール認証</router-link>
    </div>

  </div>
</template>

<script>

import ModalBackground from '@/components/common/ModalBackground';
import FormHelper from '@/components/common/FormHelper';
import CloseButton from '@/components/user/CloseButton';

export default {
  props: ['info'],
  components: {
    ModalBackground,
    FormHelper,
    CloseButton
  },
  data () {
    return {
      formSettings: { //フォームの設定を記載
        store: 'kids',
        dispatch: 'update',
        header: 'キッズ情報を変更',
        forms: {
          name: {
            label: 'なまえ',
            type: 'text',
            value: null,
            require: true,
            placeholder: 'なまえ',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          },
          age: {
            label: '年齢',
            type: 'select',
            value: null,
            require: true,
            placeholder: '',
            default: -1,
            validate: [],
            options: {
              0: {label: '未設定', value: -1},
              1: {label: '0歳', value: 0},
              2: {label: '1歳', value: 1},
              3: {label: '2歳', value: 2},
              4: {label: '3歳', value: 3},
              5: {label: '4歳', value: 4},
              6: {label: '5歳', value: 5},
              7: {label: '6歳', value: 6},
              8: {label: '7歳', value: 7},
              9: {label: '8歳', value: 8},
              10: {label: '9歳', value: 9},
              11: {label: '10歳', value: 10},
              12: {label: '11歳', value: 11},
              13: {label: '12歳', value: 12},
              14: {label: '13歳', value: 13},
              15: {label: '14歳', value: 14},
              16: {label: '15歳', value: 15},
              17: {label: '16歳', value: 16},
              18: {label: '17歳以上', value: 99},
            },
            option: {
              size: 300,
            }
          },
          sex: {
            label: '性別',
            type: 'select',
            value: null,
            require: true,
            placeholder: '',
            default: 0,
            validate: [],
            options: {
              0: {label: '未設定', value: 0},
              1: {label: '男の子', value: 1},
              2: {label: '女の子', value: 2},
            },
            option: {
              size: 300,
            }
          },
          id: {
            label: '',
            type: 'hidden',
            value: null,
            require: null,
            placeholder: '',
            default: '',
            validate: [],
            option: {}
          },
        },
        useSessionId: true,
        submit: {
          label: '変更',
          color: 'b'
        },
        info: []
      },
      option: {
        is1Button: true,
        buttonLabel: '確認',
        callback: 'KidsEditFinish',
        callbackO: 'KidsEditFinish',
        messages: ['キッズ情報を変更しました']
      },
      isActive: false,
      debugVerifyToken: null
    };
  },
  methods: {
    openModalAction: function () {
      console.log('openModalAction');
      this.isActive = true;

      // 初期値セット
      this.formSettings.forms.name.value = this.info.name;
      this.formSettings.forms.age.value = this.info.age;
      this.formSettings.forms.sex.value = this.info.sex;
      this.formSettings.forms.id.value = this.info.id;

      scrollTo(0, 0);
    },
    closeModalAction: function () {
      console.log('closeModalAction');
      this.isActive = false;
    },
    callback: function (dispatcher, value) {
      console.log('callback', dispatcher, value);

      this.isActive = false;

      // 完了メッセージ
      this.$store.dispatch('message/open', this.option).then();

    }
  }
};

</script>

<style lang="scss" scoped>

  .add-container {
    cursor: pointer;
    color: #78ACD7;
    font-size: 13px;
  }

</style>
